import React from 'react';
import styles from './FloatingMenuContainer.module.scss';

export function FloatingMenuContainer({ children }) {
  return <div className={styles.FloatingMenu}>{children}</div>;
}
